module.exports = __webpack_public_path__ + "static/media/Node.js_logo-v2.8ec087d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Node.js_logo-v2.svg
// module id = 265
// module chunks = 0